const base64UrlToBase64 = (value: string): string => {
  const base64 = value.replace(/-/g, '+').replace(/_/g, '/');

  return base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
};

export const decodeJwt = <T = Record<string, unknown>>(token: string): T =>
  JSON.parse(atob(base64UrlToBase64(token.split('.')[1])));
